import { app } from '../../../../../app';
import { Controller } from './add-seat.controller';

app.component('upgradeLicenseSeat', {
    bindings:{
        licenseDetails: '<',
        licenseTiers: '<',
    },
    controller: Controller,
    templateUrl: require('./add-seat.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/seat/add-seat.component.js